<template>
  <div class="admin-nav-primary">
    <router-link to="/manage" :class="nav_link_includes('manage')">
      <div class="admin-nav-icon">
        <i class="fas fa-user-tie"></i>
      </div>
      <span>Manage</span>
    </router-link>
    <router-link to="/communicate" :class="nav_link_includes('communicate')">
      <div class="admin-nav-icon">
        <i class="fas fa-comments"></i>
      </div>
      <span>Communicate</span>
    </router-link>
    <router-link to="/calendar" :class="nav_link_includes('calendar')">
      <div class="admin-nav-icon">
        <i class="far fa-calendar-alt"></i>
      </div>
      <span>Calendar</span>
    </router-link>
    <router-link to="/chores" :class="nav_link_includes('chores')">
      <div class="admin-nav-icon">
        <i class="fas fa-broom"></i>
      </div>
      <span>Chores</span>
    </router-link>
    <router-link to="/meals" :class="nav_link_includes('meals')">
      <div class="admin-nav-icon">
        <i class="fas fa-pizza-slice"></i>
      </div>
      <span>Meals</span>
    </router-link>
    <router-link to="/finance" :class="nav_link_includes('finance')">
      <div class="admin-nav-icon">
        <i class="fas fa-money-bill-wave"></i>
      </div>
      <span>Finance</span>
    </router-link>
    <router-link to="/maintenance" :class="nav_link_includes('maintenance')">
      <div class="admin-nav-icon">
        <i class="fas fa-tools"></i>
      </div>
      <span>Maintenance</span>
    </router-link>
    <router-link to="/contacts" :class="nav_link_includes('contacts')">
      <div class="admin-nav-icon">
        <i class="fas fa-users"></i>
      </div>
      <span>Contacts</span>
    </router-link>
    <router-link to="/vault" :class="nav_link_includes('vault')">
      <div class="admin-nav-icon">
        <i class="fas fa-lock"></i>
      </div>
      <span>Vault</span>
    </router-link>
    <router-link to="/setup" :class="nav_link_includes('setup')">
      <div class="admin-nav-icon">
        <i class="fas fa-cogs"></i>
      </div>
      <span>Setup</span>
    </router-link>
    <router-link to="/addons" :class="nav_link_includes('addons')">
      <div class="admin-nav-icon">
        <i class="far fa-plus-square"></i>
      </div>
      <span>Addons</span>
    </router-link>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class PrimaryNavigation extends Vue {
  nav_link_includes(path) {
    return [this.$route.path.includes(path) ? 'active' : '', 'admin-nav-primary-link'];
  }
}
export default PrimaryNavigation;
</script>

<style scoped>
.admin-nav-primary, .admin-nav-status {
  box-shadow: inset -11px 0 10px -10px rgba(25,29,47,.5);
}

.admin-nav-primary {
  width: 60px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
  background-color: #2c3042;
}

@media screen and (min-width: 1280px) {
  .admin-nav-primary {
    width: calc(130px - 1rem);
  }
}

@media screen and (min-width: 1440px) {
  .admin-nav-primary {
    width: 130px;
  }
}

@media screen and (min-width: 1920px) {
  .admin-nav-primary {
    width: 150px;
  }
}

.admin-nav-primary-link {
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  font-size: .75rem;
  letter-spacing: .05rem;
  text-align: center;
  color: #a0a4b6;
  background-color: #2c3042;
  box-shadow: inset -11px 0 10px -10px rgba(25, 29, 47, .5);
}

.admin-nav-primary-link > span {
  display: none;
  margin-top: .25rem;
}

.admin-nav-primary-link > .admin-nav-icon {
  display: block;
  width: 100%;
  max-width: 2rem;
  max-height: 2rem;
  font-size: 1.7rem;
  margin-left: auto;
  margin-right: auto;
  /* color: #a0a4b6; */
}

@media screen and (min-width: 1280px) {
  .admin-nav-primary-link {
    width: calc(130px - 1rem);
    min-height: calc(130px - 2rem);
    padding-top: .8rem;
    padding-bottom: .8rem;
  }

  .admin-nav-primary-link span {
    display: block;
  }

  .admin-nav-primary-link > .admin-nav-icon {
    font-size: 2.1rem;
    max-width: 2.5rem;
    max-height: 2.5rem;
  }
}

@media screen and (min-width: 1440px) {
  .admin-nav-primary-link {
    width: 130px;
    min-height: 130px;
  }
}

@media screen and (min-width: 1920px) {
  .admin-nav-primary-link {
    width: 150px;
    min-height: 150px;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}

.admin-nav-primary-link.active, .admin-nav-primary-link.active:hover {
  background: #FF6633;
  color: #ffb399;
}

.admin-nav-primary-link.slim {
  min-height: 60px;
}

.admin-nav-primary-link:hover {
  color: #cdd1e3;
  outline: none;
  text-decoration: none;
}
</style>
